import { Injectable } from '@angular/core';
import { JsonUtils } from '../../utils/json/json.utils';
import { Identity } from '../../core/models/identity/identity.model';

@Injectable({
  providedIn: 'root'
})
export class IdentityService {

  private static readonly LOCAL_STORAGE_IDENTITY_KEY = 'identity';
  private static readonly AUTH0_USERID_SEPARATOR = '|';

  private identity: Identity = undefined;

  constructor() {
    this.initIdentity();
  }

  public getIdentity(): Identity {
    return this.identity;
  }

  public getAccessToken(): string {
    return this.identity?.accessToken;
  }

  public getRefreshToken(): string {
    return this.identity?.refreshToken;
  }

  public setIdentity(email: string,
                     accessToken: string,
                     tokenExpirationDate: number,
                     refreshToken: string,
                     roles: string[]): void {
    this.identity = new Identity();
    this.identity.email = email;
    this.identity.accessToken = accessToken;
    this.identity.tokenExpirationDate = tokenExpirationDate;
    this.identity.refreshToken = refreshToken;
    this.identity.roles = roles;
    localStorage.setItem(IdentityService.LOCAL_STORAGE_IDENTITY_KEY, JSON.stringify(this.identity));
  }

  public refreshIdentity(accessToken: string,
                         tokenExpirationDate: number,
                         refreshToken: string,
                         roles: string[]): void {
    this.identity.accessToken = accessToken;
    this.identity.tokenExpirationDate = tokenExpirationDate;
    this.identity.refreshToken = refreshToken;
    this.identity.roles = roles;
    localStorage.setItem(IdentityService.LOCAL_STORAGE_IDENTITY_KEY, JSON.stringify(this.identity));
  }

  public destroyIdentity(): void {
    this.identity = undefined;
    localStorage.removeItem(IdentityService.LOCAL_STORAGE_IDENTITY_KEY);
  }

  private initIdentity(): void {
    this.identity = JsonUtils.parseJsonIfValid(localStorage.getItem(IdentityService.LOCAL_STORAGE_IDENTITY_KEY));
  }


}
